type ApiErrorData = {
  message?: string;
  error?: string;
  code?: string;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const getApiErrorData = (error: unknown): ApiErrorData | undefined => {
  if (!isRecord(error)) return undefined;
  const directData = error['data'];
  if (isRecord(directData)) return directData as ApiErrorData;
  const response = error['response'];
  if (isRecord(response) && isRecord(response['data'])) {
    return response['data'] as ApiErrorData;
  }
  return undefined;
};

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const data = getApiErrorData(error);
  if (data?.message) return data.message;
  if (data?.error) return data.error;
  if (error instanceof Error && error.message) return error.message;
  if (isRecord(error) && typeof error['message'] === 'string') return error['message'];
  return fallback;
};

export const getApiErrorStatus = (error: unknown): number | undefined => {
  if (!isRecord(error)) return undefined;
  if (typeof error['status'] === 'number') return error['status'];
  const response = error['response'];
  if (isRecord(response) && typeof response['status'] === 'number') {
    return response['status'];
  }
  return undefined;
};

export const getApiErrorCode = (error: unknown): string | undefined => {
  return getApiErrorData(error)?.code;
};
